export async function loadComponents(service) {
  try {

    const createComponent = await import(`@/components/Seller/Integrations/configs/${service}/Create.vue`);
    const listComponent = await import(`@/components/Seller/Integrations/configs/${service}/List.vue`);
    const updateComponent = await import(`@/components/Seller/Integrations/configs/${service}/Update.vue`);
    
    return {
      create: createComponent.default,
      list: listComponent.default,
      update: updateComponent.default
    };

  } catch (error) {

    const createComponent = await import(`@/components/Seller/Integrations/configs/webhook/Create.vue`);
    const listComponent = await import(`@/components/Seller/Integrations/configs/webhook/List.vue`);
    const updateComponent = await import(`@/components/Seller/Integrations/configs/webhook/Update.vue`);

    return {
      create: createComponent.default,
      list: listComponent.default,
      update: updateComponent.default
    };
  }
}